export default "__VITE_ASSET__uk_kB_ZP__"